module.exports = __webpack_public_path__ + "fonts/Golos-Text_Regular.8f52cab.woff2";